import React from 'react';
import { useTranslation } from './i18n.js';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// « Liste de vos abonnements » (sous l'abonnement à la pensée) : demande, pour l'adresse saisie,
// l'envoi par email du lien de gestion des abonnements (POST /subscriptions/link, voir
// server/subscriptionLink.mjs). Le lien reçu ouvre la boîte de gestion du site
// (public/js/subscriptions.js), alimentée par api.prosveta.com/subscriptions.
export function SubscriptionsLinkRequest() {
  const { lang, t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [website, setWebsite] = React.useState('');
  const [status, setStatus] = React.useState('idle');
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const value = email.trim();
    if (!EMAIL_PATTERN.test(value)) {
      setStatus('invalid');
      return;
    }
    setStatus('sending');
    try {
      const response = await fetch('/subscriptions/link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: value, lang, website }),
      });
      if (response.ok) {
        setStatus('sent');
      } else if (response.status === 400) {
        setStatus('invalid');
      } else if (response.status === 429) {
        setStatus('tooMany');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const errorMessage = {
    invalid: t('thoughtSubscribeInvalidEmail'),
    tooMany: t('subscriptionsListTooMany'),
    error: t('subscriptionsListError'),
  }[status];

  return (
    <div className="subscriptions-link">
      <button
        type="button"
        className="subscriptions-link__toggle"
        aria-expanded={open}
        aria-controls="subscriptions-link-panel"
        onClick={() => setOpen((value) => !value)}
      >
        {t('subscriptionsListLink')}
      </button>

      {open && (
        <div id="subscriptions-link-panel" className="subscriptions-link__panel">
          {status === 'sent' ? (
            <p className="thought-subscribe-message thought-subscribe-message--info" role="status">
              {t('subscriptionsListSent')}
            </p>
          ) : (
            <form className="thought-subscribe-form" onSubmit={handleSubmit} noValidate>
              <p className="subscriptions-link__intro">{t('subscriptionsListIntro')}</p>
              {errorMessage && (
                <p className="thought-subscribe-message thought-subscribe-message--error" role="alert">
                  {errorMessage}
                </p>
              )}
              <div className="subscriptions-link__trap" aria-hidden="true">
                <label htmlFor="subscriptions-link-website">Ne remplissez pas ce champ</label>
                <input
                  id="subscriptions-link-website"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  value={website}
                  onChange={(event) => setWebsite(event.target.value)}
                />
              </div>
              <input
                ref={inputRef}
                id="subscriptions-link-email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                  if (status !== 'sending') {
                    setStatus('idle');
                  }
                }}
                aria-label={t('thoughtSubscribeEmailPlaceholder')}
                placeholder={t('thoughtSubscribeEmailPlaceholder')}
                required
              />
              <button type="submit" disabled={status === 'sending'}>
                {status === 'sending' ? t('thoughtSubscribeSending') : t('subscriptionsListSubmit')}
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
}
